import React from 'react';
import { Footer } from '../components/Footer';
import Header from '../components/Header';

const PrivacyPolicyChinese: React.FC = () => {
  
  return (
    <div className="bg-white min-h-screen">
      {/* Shared Header Component */}
      <Header currentPage="chinese" />

      {/* Content with padding for fixed header */}
      <div className="pt-16">
        {/* Privacy Policy Content */}
        <div className="py-16 bg-white">
          <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
            <div className="text-center">
              <h1 className="text-3xl font-extrabold text-gray-900 tracking-tight sm:text-4xl">
                隐私政策
              </h1>
              <p className="mt-4 text-gray-500">
                最后更新: 2024年6月1日
              </p>
            </div>

            <div className="mt-12 prose prose-indigo prose-lg text-gray-500 mx-auto">
              <h2>引言</h2>
              <p>
                Agilis AI（"我们"、"我方"或"我们的"）致力于保护您的个人信息的隐私和安全。本隐私政策描述了我们在您使用我们的人工智能驱动的医疗助手平台和相关服务（统称为"服务"）时如何收集、使用、披露和保护您的信息。
              </p>
              <p>
                我们理解医疗信息的敏感性，并非常认真地履行保护这些信息的责任。我们致力于遵守所有适用的法律法规，包括《中华人民共和国网络安全法》、《中华人民共和国个人信息保护法》、《中华人民共和国数据安全法》以及其他相关隐私法律法规。
              </p>

              <h2>我们收集的信息</h2>
              <p>我们可能会从我们服务的用户那里收集以下几类信息：</p>
              <h3>1. 个人信息</h3>
              <ul>
                <li><strong>医疗专业人员：</strong>姓名、电子邮件地址、专业资格证书、专业领域、工作场所信息和登录凭证。</li>
                <li><strong>患者：</strong>当医疗专业人员将患者数据输入我们的系统时，我们可能会收集患者姓名、人口统计信息、医疗历史、症状、诊断、治疗计划和其他与健康相关的信息。</li>
              </ul>

              <h3>2. 使用信息</h3>
              <ul>
                <li>关于您如何使用我们的服务的信息，包括提交的查询、使用的功能和在平台上停留的时间。</li>
                <li>关于您的设备的信息，包括IP地址、操作系统、浏览器类型和设备标识符。</li>
                <li>日志数据，包括您访问的页面、访问的时间和持续时间以及您使用的搜索词。</li>
              </ul>

              <h3>3. 音频和视觉信息</h3>
              <p>
                如果您使用我们的语音界面功能或上传图像和文档，我们可能会收集您的语音录音以及从上传的图像和文档中获取的视觉信息。
              </p>

              <h2>我们如何使用您的信息</h2>
              <p>我们使用收集的信息来：</p>
              <ul>
                <li>提供、维护和改进我们的服务，包括人工智能驱动的医疗协助和洞察。</li>
                <li>开发新功能、产品和服务。</li>
                <li>处理和完成交易，并发送相关信息，包括确认和发票。</li>
                <li>发送技术通知、更新、安全警报以及支持和管理消息。</li>
                <li>回应您的评论、问题和请求，并提供客户服务。</li>
                <li>与您沟通有关产品、服务、优惠、促销和活动的信息，并提供我们认为您会感兴趣的新闻和信息。</li>
                <li>监控和分析与我们服务相关的趋势、使用情况和活动。</li>
                <li>检测、调查和防止欺诈交易和其他非法活动，并保护Agilis AI和他人的权利和财产。</li>
                <li>训练和改进我们的人工智能模型，以提高我们医疗洞察的准确性和有效性。</li>
                <li>遵守法律义务和监管要求。</li>
              </ul>

              <h2>个人信息处理的法律依据</h2>
              <p>
                我们收集和处理您的个人信息是基于以下法律依据：
              </p>
              <ul>
                <li><strong>同意：</strong>当您同意处理您的个人信息时。</li>
                <li><strong>合同必要性：</strong>当处理对于履行与您的合同或在签订合同前根据您的请求采取措施是必要的。</li>
                <li><strong>法律义务：</strong>当处理对于遵守我们所受法律义务是必要的。</li>
                <li><strong>合法利益：</strong>当处理对于我们或第三方的合法利益是必要的，除非这些利益被您的利益或基本权利和自由所覆盖。</li>
              </ul>

              <h2>我们如何共享您的信息</h2>
              <p>我们可能会与以下各方共享您的个人信息：</p>
              <ul>
                <li><strong>服务提供商：</strong>我们可能会与代表我们执行服务的第三方供应商、顾问和其他服务提供商共享您的信息，如云存储提供商、分析提供商和支付处理商。</li>
                <li><strong>医疗机构：</strong>如果您通过您的医疗机构使用我们的服务，我们可能会根据我们与他们的协议与该机构共享您的信息。</li>
                <li><strong>业务转让：</strong>如果Agilis AI涉及合并、收购或出售其全部或部分资产，您的信息可能作为该交易的一部分被转让。</li>
                <li><strong>法律要求：</strong>如果法律要求或响应公共当局（如法院或政府机构）的有效请求，我们可能会披露您的信息。</li>
                <li><strong>权利保护：</strong>我们可能会披露您的信息以保护Agilis AI、我们的用户或他人的权利、财产或安全。</li>
              </ul>
              <p>
                未经您的明确同意，我们不会将您的个人信息出售或出租给第三方用于其营销目的。
              </p>

              <h2>数据安全</h2>
              <p>
                我们实施适当的技术和组织措施来保护我们收集和处理的个人信息。这些措施包括敏感数据加密、访问控制、定期安全评估和员工培训。然而，没有任何电子传输或存储方法是100%安全的，我们不能保证绝对的安全性。
              </p>

              <h2>数据保留</h2>
              <p>
                我们保留从您那里收集的个人信息的时间不会超过为实现我们收集它的目的所必需的时间，包括满足任何法律、监管、税务、会计或报告要求的目的。如果发生投诉或我们合理相信有诉讼的可能性，我们可能会保留您的个人信息更长时间。
              </p>

              <h2>您的权利和选择</h2>
              <p>根据适用法律，您可能对您的个人信息拥有以下权利：</p>
              <ul>
                <li>访问您的个人信息。</li>
                <li>更正不准确或不完整的信息。</li>
                <li>删除您的个人信息。</li>
                <li>限制或反对处理您的个人信息。</li>
                <li>个人信息的可携带性。</li>
                <li>撤回同意，当我们依赖同意作为处理的法律依据时。</li>
              </ul>
              <p>
                要行使这些权利，请使用本隐私政策末尾提供的信息联系我们。在履行您的请求之前，我们可能需要验证您的身份。
              </p>

              <h2>儿童隐私</h2>
              <p>
                我们的服务不面向18岁以下的儿童，我们不会故意收集18岁以下儿童的个人信息。如果您是父母或监护人，并相信我们可能收集了有关儿童的信息，请立即联系我们。
              </p>

              <h2>国际数据传输</h2>
              <p>
                我们总部位于加拿大和香港，您的信息可能会在我们运营或有服务提供商的国家/地区进行处理。这些国家/地区可能有与您所在国家/地区不同的数据保护法。当您的个人信息进行国际传输时，我们会实施适当的保障措施来保护您的个人信息。
              </p>

              <h2>第三方链接和服务</h2>
              <p>
                我们的服务可能包含第三方网站、应用程序或服务的链接。我们不对这些第三方的隐私做法或内容负责。我们鼓励您在向他们提供任何信息之前阅读这些第三方的隐私政策。
              </p>

              <h2>本隐私政策的变更</h2>
              <p>
                我们可能会不时更新本隐私政策。更新后的版本将通过更新的"最后更新"日期表示，更新后的版本将在可访问后立即生效。我们鼓励您经常查看本隐私政策，以了解我们如何保护您的信息。
              </p>

              <h2>联系我们</h2>
              <p>
                如果您对本隐私政策或我们的数据做法有任何疑问，请联系我们：
              </p>
              <p>
                <strong>隐私官</strong><br />
                Agilis AI医疗助手<br />
              </p>
              <p>
                <strong>电子邮件：</strong> info@agiliscare.com<br />
              </p>
            </div>
          </div>
        </div>
      </div>

      {/* Footer */}
      <Footer />
    </div>
  );
};

export default PrivacyPolicyChinese; 